
// src/helpers/google-doc.js

export default function (url) {
  return url.match(/^https:\/\/docs\.google\.com/)
}



// WEBPACK FOOTER //
// ./src/helpers/google-doc.js